import React, { Component } from 'react';
import {
    Row, Col, Alert
} from 'react-bootstrap';
import Auth from './Auth';

class PremiumIndicator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: false
        };

        this.auth = new Auth(null);
    }

    componentDidMount() {
        let self = this

        this.auth.checkServerTokenHandler((isLoggedInParam) => {
            if(isLoggedInParam !== null) {
                self.setState({ isLoggedIn: isLoggedInParam })
            }
        })
    }

    render() { 
        return (
            <div>
                { this.state.isLoggedIn &&
                    <Row>
                        <Col xs="12" className="mb-4 mt-4 text-center">
                            <Alert variant="success">Premium Mode On</Alert>
                        </Col>
                    </Row>
                }
            </div>
        )
    }

}

export default PremiumIndicator;